import React from 'react';
import { List, Form,  Button, Message} from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';

//utils

import queries from '../../../utils/queries'
import TitDer from '../../../components/funcionales/titder';
import EstaSeguro from '../../../components/funcionales/estaseg7btn';
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({elemento, handleClickidLista, idLista}) => {
  let urlSlcm = 'https://montserratslcm.com/api/imgorden/'

  let colorCelda='white'
  if(elemento.estadoOrden==='Cerrado' && elemento.realizado==='S'){
    colorCelda = 'green'
  }
  return( 
    <tr className=''>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ruta}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numeroOrden}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estadoOrden}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrPlanta}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrSeccion}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEquipo}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrComponente}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrMecanismo}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.nombreUsuario}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrMetodo}</td>
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrTarea}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.realizado}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaProg?elemento.fechaProg.substr(0, 10):''}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaReal?elemento.fechaReal.substr(0, 10):''}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.minutosReal}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fallaLub?elemento.fallaLub:'N'}</td>   
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.tiempoFalla?elemento.tiempoFalla:0}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.costoFalla?elemento.costoFalla:0}</td>             
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          href={urlSlcm + elemento.archivoRCA}
            target="_blank">
          {elemento.archivoRCA}
        </a>
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
        {elemento.imgAntes &&
           <img src={urlSlcm + elemento.imgAntes} height = {70} width = {100} alt="Imagen"/>
        }
        {!elemento.imgAntes &&
          ""
        }
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
        {elemento.imgDespues &&
           <img src={urlSlcm + elemento.imgDespues} height = {70} width = {100} alt="Imagen"/>
          }
        {!elemento.imgDespues &&
          ""
        }
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
        {elemento.videoAntes &&
          <video controls src={urlSlcm + elemento.videoAntes} height = {70} width = {100} alt="Video">
          </video>
        }
        {!elemento.videoAntes &&
          ""
        }
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
        {elemento.videoDespues &&
           <video controls src={urlSlcm + elemento.videoDespues} height = {70} width = {100} alt="Video">
           </video>
        }
        {!elemento.videoDespues &&
          ""
        }
      </td>      
      <td className='left aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
            background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.observacionesReal}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista, idLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 elemento={elemento} handleClickidLista={handleClickidLista}
        key={i} idLista={idLista}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};




// const ConfEmpresa2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
class ProgOtHallazgo2 extends React.Component {  
  state={argsBuscProg: {}, idLista: {}, procBtn: 0, permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, permiteBtn4: true, permiteBtn5: true, confirmaAct: false, 
  open: false}


  handleClickidLista = async (ev, idLista)=>{
    ev.preventDefault()
      this.setState({idLista: idLista})
  }

  componentDidUpdate(prevProps){
      if(this.props.argsBuscProg!==this.state.argsBuscProg){
          let argsBuscar = `'descrMetodo': 'Hallazgo'`

          if(this.props.argsBuscProg.descrEmpresa){
            argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscProg.descrEmpresa}/i`
          }          
          if(this.props.argsBuscProg.descrPlanta){
            argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
          }
          if(this.props.argsBuscProg.descrSeccion){
            argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
          }
          if(this.props.argsBuscProg.descrEquipo){
            argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
          }
          if(this.props.argsBuscProg.descrComponente){
            argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
          }
          if(this.props.argsBuscProg.descrMecanismo){
            argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
          }
          if(this.props.argsBuscProg.estadoOrden){
            argsBuscar += `, 'estadoOrden': /${this.props.argsBuscProg.estadoOrden}/i`
          }
          if(this.props.argsBuscProg.ruta){
            argsBuscar += `, 'ruta': ${this.props.argsBuscProg.ruta}`
          }
          if(this.props.argsBuscProg.numeroOrden){
            argsBuscar += `, 'numeroOrden': ${this.props.argsBuscProg.numeroOrden}`
          }
          if(this.props.argsBuscProg.realizado){
            argsBuscar += `, 'realizado': /${this.props.argsBuscProg.realizado}/i`
          } 

          let argsBuscProg = ""
          if(this.props.argsBuscProg.numDocum){
            argsBuscProg = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroOrden: -1}}, {$limit: ${this.props.argsBuscProg.numDocum}}]`}
          }else{
            argsBuscProg = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {numeroOrden: -1}}, {$limit: 100}]`}
          }
    console.log(argsBuscProg)
          this.props.allOrdenRtes.refetch(argsBuscProg)
    
          this.setState({argsBuscProg: this.props.argsBuscProg, permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, permiteBtn4: true, permiteBtn5: true, open: false, confirmaAct: false})

        }
      }

      handleQuestionUpdDel = async (ev, btn) => {
        console.log(btn, this.state.confirmaAct, this.state.procBtn)
        var btnPress = await ev.target.attributes[0].value
        if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
          console.log(btn)
          this.setState({open: true})
          this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false, permiteBtn3: btn==="3"?true:false, permiteBtn4: btn==="4"?true:false, permiteBtn5: btn==="5"?true:false})
        }else{
          console.log(btn)
          this.setState({open: false})
          this.setState({procBtn: 0})
          this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, permiteBtn4: true, permiteBtn5: true})
        };
        if(btnPress==="No"){
          this.setState({open: false})
          this.setState({procBtn: 0})
          this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, permiteBtn4: true, permiteBtn5: true})
        };
        if(btnPress==="Si"){
          console.log(btn)
          this.setState({confirmaAct: true})
          this.setState({open: false})
          this.setState({procBtn: 1})
          this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false, permiteBtn3: btn==="3"?true:false, permiteBtn4: btn==="4"?true:false, permiteBtn5: btn==="5"?true:false})
          console.log(this.state.permiteBtn1, this.state.permiteBtn2, this.state.permiteBtn3, this.state.permiteBtn4, this.state.permiteBtn5)
          const myBtn = document.getElementById("btnUpdDel");
          console.log(myBtn)
          myBtn.click()
        }
      }
    
  handleElimImgOT = async (ev, idLista, Img)=>{
    console.log(Img, idLista)
    if(idLista.numeroOrden){
      let argsUpd = {}
      if(Img==='A'){
        argsUpd = {
          "tipoAct": 'EditarImgAntes',
          "imgAntes": '',
          "numeroOrden": idLista.numeroOrden,
          "ruta": idLista.ruta
        }
      }
      if(Img==='D'){
        argsUpd = {
          "tipoAct": 'EditarImgDespues',
          "imgDespues": '',
          "numeroOrden": idLista.numeroOrden,
          "ruta": idLista.ruta
        }
      }
      if(Img==='VA'){
        console.log("Eliminar video antes")
        argsUpd = {
          "tipoAct": 'EditarVideoAntes',
          "videoAntes": '',
          "numeroOrden": idLista.numeroOrden,
          "ruta": idLista.ruta
        }
      }
      if(Img==='VD'){
        argsUpd = {
          "tipoAct": 'EditarVideoDespues',
          "videoDespues": '',
          "numeroOrden": idLista.numeroOrden,
          "ruta": idLista.ruta
        }
      }
      if(Img==='R'){
        argsUpd = {
          "tipoAct": 'EditarRCA',
          "archivoRCA": '',
          "numeroOrden": idLista.numeroOrden,
          "ruta": idLista.ruta
        }
      }
      console.log(Img, argsUpd)
      let response = await this.props.editOrden({
        variables: argsUpd
      });
      const {errors, success} = response.data.editOrden;

      document.body.style.cursor = 'default'
      alert("!! Archivo eliminado !!")

      const argsBuscProg = this.state.argsBuscProg
      this.setState({argsBuscProg});
      this.props.allOrdenRtes.refetch()
    }else{
      alert("!! Por favor seleccione la OT de la imagen o video a eliminar !!")
    }
  }
    

  render(){ 
    let urlSlcm = 'https://montserratslcm.com/api/imgorden/'
    const {idLista, permiteBtn1, permiteBtn2, permiteBtn3, permiteBtn4, permiteBtn5, confirmaAct, open} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let list = []
    // const a250101 = this.props.autorizacUA.findIndex( autorizac => autorizac === "250101" );
// console.log(idLista)
    let mensaje1 = "Eliminar imagen antes de OT "
    let mensajeAsImgOT = "Asociar imagen antes de OT "
    let mensaje2 = "Eliminar imagen después de OT "
    let mensajeAsImgOT2 = "Asociar imagen después de OT "
    let mensaje3 = "Eliminar video antes de OT "
    let mensajeAsImgOT3 = "Asociar video antes de OT "
    let mensaje4 = "Eliminar video después de OT "
    let mensajeAsImgOT4 = "Asociar video después de OT "
    let mensaje5 = "Eliminar informe RCA "
    let mensajeAsImgOT5 = "Asociar informe RCA "

      if(idLista.numeroOrden){
        mensaje1 += idLista.numeroOrden
        mensajeAsImgOT += idLista.numeroOrden
        mensaje2 += idLista.numeroOrden
        mensajeAsImgOT2 += idLista.numeroOrden
        mensaje3 += idLista.numeroOrden
        mensajeAsImgOT3 += idLista.numeroOrden
        mensaje4 += idLista.numeroOrden
        mensajeAsImgOT4 += idLista.numeroOrden
        mensaje5 += idLista.numeroOrden
        mensajeAsImgOT5 += idLista.numeroOrden
      }else{
        mensaje1 += "(Seleccionar...)"
        mensajeAsImgOT += "(Seleccionar...)"
        mensaje2 += "(Seleccionar...)"
        mensajeAsImgOT2 += "(Seleccionar...)"
        mensaje3 += "(Seleccionar...)"
        mensajeAsImgOT3 += "(Seleccionar...)"
        mensaje4 += "(Seleccionar...)"
        mensajeAsImgOT4 += "(Seleccionar...)"
        mensaje5 += "(Seleccionar...)"
        mensajeAsImgOT5 += "(Seleccionar...)"
      }

      let imgIcon1 = "images/archivo_32.png"

      this.props.allOrdenRtes.refetch()

    if(this.props.allOrdenRtes.allOrdenRtes){list = this.props.allOrdenRtes.allOrdenRtes}
    let listHa = list
    if(this.props.descrEmpresaUA!=="Todas..."){
      listHa = list.filter(elemento => elemento.descrEmpresa===this.props.descrEmpresaUA)
    }
    return (
      <div>
        <List selection>
          <TitDer list={listHa} textBoton1="Ordenes de trabajo por hallazgos" btnNuevo={"SI"} styles={this.props.styles} handleClick={this.props.handleClick} />
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            permiteBtn1?
              (ev)=>this.handleElimImgOT(ev, idLista, 'A')
              :permiteBtn2?
                (ev)=>this.handleElimImgOT(ev, idLista, 'D')
                :permiteBtn3?
                  (ev)=>this.handleElimImgOT(ev, idLista, 'VA')
                  :permiteBtn4?
                    (ev)=>this.handleElimImgOT(ev, idLista, 'VD')
                    :permiteBtn5?
                      (ev)=>this.handleElimImgOT(ev, idLista, 'R')
                      :()=>{}                
            :()=>{}}
          > 
            <div className="ui five column stackable grid">
              <div className="row container">
                {idLista.numeroOrden && !idLista.imgAntes &&
                  <div className="column" style={{width: '20%', paddingTop: '2.5em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        {mensajeAsImgOT}&nbsp;&nbsp;
                      </label>
                      <input id="img1" name="img1" type="file" accept="image/*" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsImgOT(ev, idLista, 'A')}></input>
                    </Form.Field>  
                  </div>
                }
                {idLista.numeroOrden && idLista.imgAntes &&
                  <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        &nbsp;&nbsp;
                      </label>
                      <hr></hr>
                      <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>                    
                    </Form.Field>                  
                  </div>
                }
                {idLista.numeroOrden && !idLista.imgDespues &&
                  <div className="column" style={{width: '20%', paddingTop: '2.5em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        {mensajeAsImgOT2}&nbsp;&nbsp;
                      </label>
                      <input id="img2" name="img2" type="file" accept="image/*" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsImgOT(ev, idLista, 'D')}></input>
                    </Form.Field>  
                  </div>
                }      
                {idLista.numeroOrden && idLista.imgDespues &&
                  <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        &nbsp;&nbsp;
                      </label>
                      <EstaSeg7Btn mensaje2={mensaje2} imgIcon2={imgIcon1} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>                    
                    </Form.Field>                  
                  </div>
                }
                {idLista.numeroOrden && !idLista.videoAntes &&
                  <div className="column" style={{width: '20%', paddingTop: '2.5em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        {mensajeAsImgOT3}&nbsp;&nbsp;
                      </label>
                      <input id="img3" name="img3" type="file" accept="video/*" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsImgOT(ev, idLista, 'VA')}></input>
                    </Form.Field>  
                  </div>
                }
                {idLista.numeroOrden && idLista.videoAntes &&
                  <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        &nbsp;&nbsp;
                      </label>
                      <hr></hr>
                      <EstaSeg7Btn mensaje3={mensaje3} imgIcon1={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "3")}/>                    
                    </Form.Field>                  
                  </div>
                }
                {idLista.numeroOrden && !idLista.videoDespues &&
                  <div className="column" style={{width: '20%', paddingTop: '2.5em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        {mensajeAsImgOT4}&nbsp;&nbsp;
                      </label>
                      <input id="img4" name="img4" type="file" accept="video/*" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsImgOT(ev, idLista, 'VD')}></input>
                    </Form.Field>  
                  </div>
                }      
                {idLista.numeroOrden && idLista.videoDespues &&
                  <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        &nbsp;&nbsp;
                      </label>
                      <EstaSeg7Btn mensaje4={mensaje4} imgIcon2={imgIcon1} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "4")}/>                    
                    </Form.Field>                  
                  </div>
                }
                {idLista.numeroOrden && !idLista.archivoRCA &&
                  <div className="column" style={{width: '20%', paddingTop: '2.5em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        {mensajeAsImgOT5}&nbsp;&nbsp;
                      </label>
                      <input id="img5" name="img5" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={(ev)=>this.props.handleUpdAsImgOT(ev, idLista, 'R')}></input>
                    </Form.Field>  
                  </div>
                }      
                {idLista.numeroOrden && idLista.archivoRCA &&
                  <div className="column" style={{width: '20%', paddingTop: '0.3em'}}>
                    <Form.Field>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        &nbsp;&nbsp;
                      </label>
                      <EstaSeg7Btn mensaje5={mensaje5} imgIcon2={imgIcon1} open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "5")}/>                    
                    </Form.Field>                  
                  </div>
                }                
              </div>
            </div>            
            <div style={{height: '30em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Ruta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Orden</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Estado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Empresa</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Mecanismo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Responsable</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Método</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Tarea</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Realiz.</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha prog.</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha real</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Min.</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Falla por lubricación?</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Duración falla (Horas)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Costo de falla ($)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Informe RCA</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Img antes</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Img después</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Video antes</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Video después</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '255%'}}>Observaciones</th>
                  </tr>
                </thead>
                <Lista list={listHa} handleClickidLista={this.handleClickidLista} idLista={idLista}/>
              </table>
              <p></p>
            </div>
            <hr></hr>
            
            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    {/* <img src={idLista.imgAntes?'https://montserratslcm.com/api/imgorden/' + idLista.imgAntes:""} width='80%'></img> */}
                    <img src={idLista.imgAntes?urlSlcm + idLista.imgAntes:""} width='70%'></img>
                  </div>
                </div>
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    {/* <img src={idLista.imgDespues?'https://montserratslcm.com/api/imgorden/' + idLista.imgDespues:""} width='80%'></img> */}
                    <img src={idLista.imgDespues?urlSlcm + idLista.imgDespues:""} width='70%'></img>
                  </div>
                </div>
              </div>
              <div className="row container">
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    {idLista.videoAntes &&
                      <video src={idLista.videoAntes?urlSlcm + idLista.videoAntes:""} width='80%' controls></video>
                    }
                  </div>
                </div>
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    {idLista.videoDespues &&
                      <video src={idLista.videoDespues?urlSlcm + idLista.videoDespues:""} width='80%' controls></video>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </List>
      </div>
    )
  }
};

export default compose(
  // graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
  //   options: (props) => {return {variables: {tipoqry: `[]`}}}})
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrMetodo: 'Hallazgo'}}, {$sort: {numeroOrden: -1}}]`}}}}),
  graphql(queries.mutation.editOrden, {name:'editOrden'}),

)(ProgOtHallazgo2) 
